import React from 'react';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from './Button';

/**
 * Button with Icon Component
 * @param param0 
 * @returns 
 */
export const ButtonWithIcon: React.FunctionComponent<{
    name?: string;
    icon: IconDefinition;
    className?: string;
    onClick?: () => void;
    disabled?: boolean;
    type?: "button" | "submit" | "reset" | undefined;
    id?:string;
}> = function ({ name, icon, className, onClick, disabled, type, id }) {
    return (
        <Button className={className} type={type} onClick={onClick} disabled={disabled} id={id}>
            <div className="flex-row d-flex align-items-center">
                <div>
                    <FontAwesomeIcon size='sm' icon={icon}></FontAwesomeIcon>
                </div>
                {
                    name!==undefined?<p className="m-0 ms-2 body2">{name}</p>:""
                }

            </div>
        </Button>
    );
}